import Cookies from 'js-cookie';
import { useUserStoreHook } from '@/store/modules/user';
import { storageLocal, isString, isIncludeAllChildren } from '@pureadmin/utils';

export const userKey = 'user-info';
export const TokenKey = 'authorized-token';
/**
 * 通过`multiple-tabs`是否在`cookie`中，判断用户是否已经登录系统，
 * 从而支持多标签页打开已经登录的系统后无需再登录。
 * 浏览器完全关闭后`multiple-tabs`将自动从`cookie`中销毁，
 * 再次打开浏览器需要重新登录系统
 * */
export const multipleTabsKey = 'multiple-tabs';

/**
 * @description 设置`token`以及一些必要信息并采用无感刷新`token`方案
 */
export function setToken(token: string) {
  // Cookies.set(TokenKey, token);
  localStorage.setItem(TokenKey, token);
}

export function getToken() {
  // return Cookies.get(TokenKey);
  return localStorage.getItem(TokenKey) || '';
}

/** 删除`token`以及key值为`user-info`的localStorage信息 */
export function removeToken() {
  Cookies.set(TokenKey, '');
  Cookies.remove(multipleTabsKey);
  storageLocal().removeItem(TokenKey);
  storageLocal().removeItem(userKey);
}

/** 是否有按钮级别的权限（根据登录接口返回的`permissions`字段进行判断）*/
export const hasPerms = (value: string | Array<string>): boolean => {
  if (!value) return false;
  const allPerms = '*:*:*';
  const { permissions } = useUserStoreHook();
  if (!permissions) return false;
  if (permissions.length === 1 && permissions[0] === allPerms) return true;
  const isAuths = isString(value)
    ? permissions.includes(value)
    : isIncludeAllChildren(value, permissions);
  return isAuths ? true : false;
};
